// App Store badge — sticky footer shown beneath every page.
// Uses the user-provided custom neon-glow artwork as a placeholder until
// the iOS app is approved; then `APP_STORE_URL` can be swapped to the live
// App Store listing.
const APP_STORE_URL = "https://apps.apple.com/us/app/mirrors-96/id6760985452";
const BADGE_IMG = "https://customer-assets.emergentagent.com/job_3a6acb3e-074e-41f3-a0be-676978ae6151/artifacts/bcq21e25_BA4E155A-49E9-4704-B9E6-0D91C8C6B032.png";

export default function AppStoreBadge() {
  return (
    <div className="flex items-center justify-center pt-6 pb-32 px-4" data-testid="app-store-badge-wrap">
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block group transition-transform hover:scale-105"
        aria-label="Download on the App Store (coming soon)"
        data-testid="app-store-badge"
      >
        <img
          src={BADGE_IMG}
          alt="Download on the App Store"
          className="h-20 sm:h-24 w-auto object-contain"
          style={{
            mixBlendMode: "screen",
            // Crush the grainy near-black background of the source PNG to
            // pure black so `mix-blend: screen` knocks it out cleanly,
            // leaving only the glowing white button visible.
            filter: "brightness(1.25) contrast(1.7)",
          }}
          loading="lazy"
          draggable={false}
        />
      </a>
    </div>
  );
}
